import type { MyESETEnvData } from './types'

const envData: MyESETEnvData = {
  AutorunIntent: 'false',
  ContactSupportURL: 'https://help.eset.com/getHelp?product=home_eset&lang=<0>',
  DeeplinkHost: 'dev-appreg.eset.com',
  EMSTokenIntentUrl:
    'intent://dev-appreg.eset.com/ems/token?data={tokenData}#Intent;scheme=ems;package=com.eset.ems2.gp;end',
  EMSTokenFallbackUrl:
    'https://play.google.com/store/apps/details?id=com.eset.ems2.gp&referrer=utm_medium%3Ddeeplink%26utm_content%3D{deeplink}',
  HomeAssetUrl: 'https://dev-assets.eset.com',
  HomePortalUrl: 'https://dev-home.eset.com/',
}

export default envData
